import { BookOpen, CircleDot, Compass, Eye, Flame, HandHeart, Library, Moon, Sparkles } from 'lucide-react';
import type { LibraryResource, NavItem, Pillar } from './types';

export const shopUrl = 'https://societyofmystics.org/shop';

export const navItems: NavItem[] = [
  { label: 'About', href: '#about' },
  { label: 'Start Here', href: '#start-here' },
  { label: 'Library', href: '#library' },
  { label: 'Join Us', href: '#join' },
  { label: 'Contact', href: '#contact' },
  { label: 'Shop', href: shopUrl, external: true }
];

export const pillars: Pillar[] = [
  {
    title: 'Experiential Wisdom',
    description: 'Direct inner experience as the primary source of mystical growth, reflection, and insight.',
    icon: Eye
  },
  {
    title: 'Interfaith Understanding',
    description: 'A shared table for many traditions, contemplative languages, and sincere seekers.',
    icon: Compass
  },
  {
    title: 'Personal Transformation',
    description: 'Practice that becomes compassion, clarity, empathy, and embodied unity in daily life.',
    icon: Sparkles
  },
  {
    title: 'Holistic Perspective',
    description: 'Body, mind, spirit, cosmos, and community held as one interconnected field.',
    icon: CircleDot
  }
];

export const pathCards = [
  {
    title: 'Remembering',
    eyebrow: 'Foundation',
    description: 'Recognize the shape of mystical experience across cultures and within yourself.',
    icon: BookOpen
  },
  {
    title: 'Journeying',
    eyebrow: 'Passage',
    description: 'Enter the territory through myth, practice, primary texts, and direct contemplation.',
    icon: Moon
  },
  {
    title: 'Becoming',
    eyebrow: 'Integration',
    description: 'Let practice become life as insight returns to ordinary action and relationship.',
    icon: Flame
  }
];

export const libraryResources: LibraryResource[] = [
  {
    title: 'Suggested Reading',
    description: 'Foundational reading lists for mysticism, myth, and cross-tradition study.',
    type: 'Reading'
  },
  {
    title: 'The Enmyo Path',
    description: 'A culture-agnostic curriculum of remembering, journeying, and becoming.',
    type: 'Practice'
  },
  {
    title: 'Downloadable Resources',
    description: 'PDFs and practice materials will be served from Cloudflare R2 as the library grows.',
    type: 'Download'
  }
];

export const contactActions = [
  { label: 'Ask a Question', href: 'mailto:contact@societyofmystics.org', icon: HandHeart },
  { label: 'Explore the Library', href: '#library', icon: Library }
];
